import { useState, useEffect } from 'react';

/**
 * Custom hook to manage login state across the application
 * Listens for localStorage changes and custom logout events
 */
export const useLoginState = () => {
  const [isLoggedIn, setIsLoggedIn] = useState(!!localStorage.getItem("FWToken"));

  useEffect(() => {
    const checkLoginState = () => {
      const token = localStorage.getItem("FWToken");
      setIsLoggedIn(!!token);
    };

    // Check on mount
    checkLoginState();

    // Listen for storage events (logout in other tabs)
    const handleStorageChange = (e) => {
      if (e.key === "FWToken") {
        checkLoginState();
      }
    };

    // Listen for custom logout event
    const handleLogout = () => {
      checkLoginState();
    };

    // Listen for custom login event
    const handleLogin = () => {
      checkLoginState();
    };

    window.addEventListener("storage", handleStorageChange);
    window.addEventListener("logout", handleLogout);
    window.addEventListener("login", handleLogin);

    return () => {
      window.removeEventListener("storage", handleStorageChange);
      window.removeEventListener("logout", handleLogout);
      window.removeEventListener("login", handleLogin);
    };
  }, []);

  return [isLoggedIn, setIsLoggedIn];
};

/**
 * Helper function to perform logout
 * Clears localStorage and dispatches logout event
 */
export const performLogout = () => {
  localStorage.removeItem("FWToken");
  localStorage.removeItem("FWUser");
  
  // Dispatch custom logout event to notify all components
  window.dispatchEvent(new CustomEvent("logout"));
};

/**
 * Helper function to perform login
 * Sets token in localStorage and dispatches login event
 */
export const performLogin = (token, user) => {
  localStorage.setItem("FWToken", token);
  localStorage.setItem("FWUser", JSON.stringify(user));
  
  // Dispatch custom login event to notify all components
  window.dispatchEvent(new CustomEvent("login"));
};
